import React, { useEffect, useState } from "react";
import { Collapse, Input, Label } from "reactstrap";
import { mdiChevronRight, mdiChevronDown } from '@mdi/js';
import { connect } from "react-redux";
import { map } from "lodash";
import Icon from '@mdi/react';

import { isUserAllowed } from "../../../../shared/utils";
import { needsOffert } from "../../../../helper/constants";
import { getReasons } from "../../../../redux/actions/managementActions";

import AdjudgeContent from "./AdjudgeContent";
import NewGestionCRMComponent from "./NewGestionCRMComponent";

const AdjudgeComponent = ({
  getReasons,
  newManagementHandler,
  secondDataHandler,
  valuesHandler,
  labelsHandler,
  noAdjugde,
  offerts,
  reasons,
}) => {
  const { labels, setLabels } = labelsHandler;
  const { newManagement, setData } = newManagementHandler;
  const { secondData, setSecondData } = secondDataHandler

  const [openCollapse, setOpen] = useState('');

  useEffect(() => { getReasons() }, [getReasons]);

  const handleCollapseToggle = (id) => {
    setOpen((openCollapse === id) ? '' : id);
  }

  return (
    <div className="crm-modal-adjudge-container">
      {noAdjugde &&
        <div className="crm-modal-form-group">
          <div className="crm-modal-input-group">
            <Label>Motivos</Label>
            <Input
              className='crm-modal-input-text'
              type='select'
              value={newManagement.reason}
              disabled={reasons.loading}
              onChange={(e) => {
                setData({
                  ...newManagement,
                  reason: e.target.value,
                  comment: e.nativeEvent.target[e.nativeEvent.target.selectedIndex].text
                })
                setLabels({ ...labels, reason: e.nativeEvent.target[e.nativeEvent.target.selectedIndex].text });
              }}
              required={noAdjugde}
            >
              <option key='select' value=''>
                Seleccione
              </option>
              {map(reasons.data, (e, index) => (
                <option key={`${e._id} ${index}`} value={e._id}>
                  {e.name}
                </option>
              ))}
            </Input>
          </div>
        </div>}
      {
        labels.reason !== needsOffert && secondData.adjudge && map(offerts.data, (o, index) =>
          <div key={`${o._id}-${index}`} className="crm-modal-adjudge-collapse-container">
            <div className="crm-modal-collapse-actions">
              <div className="crm-adjudge">
                <button type="button" onClick={() => handleCollapseToggle(o._id)}>
                  <Icon path={o.id === openCollapse ? mdiChevronDown : mdiChevronRight} size={0.9} />
                  {`${o.advisor.firstName} ${o.advisor.lastName}`}
                </button>
                <div className="crm-modal-radio-container">
                  <input
                    type="radio"
                    id="radio-adjudge"
                    name="radio-adjudge"
                    value={o._id}
                    onChange={(e) => setSecondData({ ...secondData, adjudgedOffert: e.target.value })}
                    checked={secondData.adjudgedOffert === o._id}
                    disabled={noAdjugde}
                  />
                  <div className="crm-modal-label" onClick={() => !noAdjugde && setSecondData({ ...secondData, adjudgedOffert: o._id })}>
                    Adjudicar
                  </div>
                </div>
              </div>
            </div>
            <Collapse isOpen={o._id === openCollapse}>
              <AdjudgeContent offert={o} />
            </Collapse>
          </div>
        )
      }
      {labels.reason === needsOffert && <NewGestionCRMComponent valuesHandler={valuesHandler} />}
      {!offerts.data && !offerts.loading && isUserAllowed('sales-executive-sc') && <div className="crm-modal-max-offerts">No hay ofertas</div>}
    </div >
  );
}

const mapStateToProps = ({ offering, management }) => ({
  reasons: management.reasons,
  offerts: offering.offerts,
});

const mapDispatchToProps = {
  getReasons
};

export default connect(mapStateToProps, mapDispatchToProps)(AdjudgeComponent);